import { Divider, Drawer, Table, Tag } from 'antd';
import { OfferLaborExtra } from 'DTOS/Offer/OfferLaborExtra';
import { Offer } from 'DTOS/Offer/Response/Offer';
import { OfferWorkPlaceItem } from 'DTOS/Offer/Response/OfferWorkPlaceItem';
import moment from 'moment';
import React from 'react';
import { Column } from '../../utils/column';

interface OfferInformationProps {
  handleModalInformationClose: () => void;
  modalInformation: boolean;
  selectedRecord: Offer | null;
}

const OfferInformation: React.FC<OfferInformationProps> = ({
  handleModalInformationClose,
  modalInformation,
  selectedRecord,
}) => {
  const isSmallScreen = window.innerWidth <= 720;
  const deviceColumns: Column[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Denumire',
      dataIndex: ['device', 'name'],
      key: 'deviceName',
      render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
      title: 'Model',
      dataIndex: ['device', 'model'],
      key: 'model',
    },
    {
      title: 'Periodicitate',
      dataIndex: 'period',
      key: 'period',
    },
    {
      title: 'Bucati',
      dataIndex: 'piece',
      key: 'piece',
    },
    {
      title: 'Pret/Device',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Pret Total',
      dataIndex: '',
      key: 'total',
      render: (_text: string, record: OfferWorkPlaceItem) => record.piece * record.price,
    },
    {
      title: 'Persoana Contact',
      dataIndex: ['offerWorkPlaceMetadata', 'agent', 'name'],
      key: 'contactPerson',
    },
    {
      title: 'Locatia',
      dataIndex: ['offerWorkPlaceMetadata', 'workPlace', 'name'],
      key: 'location',
    },
  ];

  const laborExtraColumns: Column[] = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      hidden: true,
    },
    {
      title: 'Labor Extra Name',
      dataIndex: ['laborExtra', 'name'],
      key: 'laborExtraName',
      render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
      title: 'Bucati',
      dataIndex: 'piece',
      key: 'piece',
    },
    {
      title: 'Pret',
      dataIndex: 'price',
      key: 'price',
    },
    {
      title: 'Pret Total',
      dataIndex: '',
      key: 'total',
      render: (record: OfferLaborExtra) => record.piece * record.price,
    },
    {
      title: 'Unit Measure',
      dataIndex: 'unitMeasure',
      key: 'unitMeasure',
    },
  ];

  return (
    <Drawer
      title={`Informatii suplimentare`}
      placement={'right'}
      onClose={handleModalInformationClose}
      open={modalInformation}
      width={isSmallScreen ? '95%' : '50%'}
      key={'drawer_right'}
    >
      <h2>Oferta Nr. {selectedRecord?.number}</h2>
      <Tag color='purple' style={{ fontSize: 15 }}>
        {selectedRecord?.enumOfferStatus?.name}
      </Tag>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Client:</span>{' '}
        {selectedRecord?.metadata?.company?.name ?? selectedRecord?.company?.name}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Data:</span> {moment(selectedRecord?.date).format('DD.MM.YYYY')}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Data Interval:</span>{' '}
        {moment(selectedRecord?.dateStart).format('DD.MM.YYYY')} -{' '}
        {moment(selectedRecord?.dateEnd).format('DD.MM.YYYY')}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Periodicitate:</span>{' '}
        {moment(selectedRecord?.datePeriod).format('DD.MM.YYYY')}
      </p>
      <p style={{ fontSize: 16 }}>
        <span style={{ fontWeight: 'bold' }}>Achizitie:</span> {selectedRecord?.acquisitionType}
      </p>

      <Divider />

      <h2>Device</h2>
      <Table
        bordered
        pagination={false}
        columns={deviceColumns}
        dataSource={selectedRecord?.offerWorkPlaceItems || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />

      <h2>Manopera</h2>
      <Table
        bordered
        pagination={false}
        columns={laborExtraColumns}
        dataSource={selectedRecord?.offerLaborExtras || []}
        scroll={{
          x: 'calc(600px + 80%)',
          y: 560,
        }}
        rowKey='id'
      />
    </Drawer>
  );
};

export default OfferInformation;
